import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Genome } from 'src/providers/genome/genome';
import { Client } from 'src/providers/client/client';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';

@Component({
    selector: 'add-maintenance-items-onboarding',
    templateUrl: './add-maintenance-items-onboarding.html',
    styleUrls: ['./add-maintenance-items-onboarding.scss'],
    standalone: false
})

export class AddMaintenanceItemsOnboarding implements OnInit {

  maintenanceItems: any[];
  addresses: any[] = [];
  form: UntypedFormGroup;
  loaded = false;
  addedItems: any[] = [];
  submitted = false;


  boundAddItem = this.addItem.bind(this);
  boundSaveItems = this.saveItems.bind(this);

constructor(
    private fb: UntypedFormBuilder,
    private genome: Genome,
    private client: Client,
    private util: Util,
    private onboardingProvider: OnboardingProvider,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService
  ) {
    this.form = this.fb.group({
      newItem: ['', Validators.required],
    });
  }

  async ngOnInit() {
    const [addresses, categories] = await Promise.all([
      this.client.getAddresses(),
      this.genome.getCategories()
    ]);
    this.addresses = addresses;
    this.maintenanceItems = categories.filter((c) => !c.consumable).map((category) => ({
      viewValue: category.name,
      value: category.id,
      icon: category?.default_icon_url,
    }));
    this.maintenanceItems.filter((item) => item.name !== 'Stove + Oven Combo').forEach((item) => {
      this.addedItems.push(item);
    });
    this.loaded = true;
  }

  addItem(): void {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    const item = this.maintenanceItems.find((maintenanceItem) => maintenanceItem.value === this.form.value.newItem);
    this.addedItems.unshift(item);
  }

  removeItem(item: any): void {
    this.addedItems = this.addedItems.filter((i) => i.value !== item.value);
  }

  async saveItems() {
    this.submitted = false;
    try {
      const payload = {
        address_ids: this.addresses.map((address) => address.id),
        room_objects: this.addedItems.map((item) => ({
          category_id: item.value
        })),
      };
      await Promise.all([
        this.genome.createManyRoomObjects(payload),
        this.onboardingProvider.markGoalAsCompleted('selectMaintenance'),
      ]);
      this.rightSidePanelService.setDialogPageTitle('Getting Started');
      this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      this.onboardingProvider.setShowOnboardingInHeader(true);
      this.util.showSuccess('Items saved succesfully');
    } catch (error) {
      const errorMessage = error?.err?.message || 'Error saving items';
      this.util.showError(errorMessage);
    }
  }

}
